import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'

import { BoxForm, CodeField, NumberField } from 'components/Form'
import TextField, { TextFieldProps } from 'components/Form/TextField'
import { PrebidModulesContext } from 'features/globalSetup/contexts/PrebidModulesContext'
import { PrebidModuleParameter } from 'features/globalSetup/types/prebidModule'
import { WorkspacePrebidModuleParameter } from 'features/globalSetup/types/workspacePrebidModule'
import { ParamsSchema } from '../../schemas/paramsSchema'
import { CODE_FIELD_HEIGHT } from './constants'
import { ParamsFormBoxProps } from './types'
import { prepareValue } from './utils'

export const ParamsFormBox = ({
  isDisabled,
  parametersSchema,
}: ParamsFormBoxProps): React.JSX.Element => {
  const { workspacePrebidModule } = useContext(PrebidModulesContext)
  const { control, register } = useFormContext<ParamsSchema>()

  const parameters: WorkspacePrebidModuleParameter[] =
    (workspacePrebidModule?.parameters as WorkspacePrebidModuleParameter[]) || []

  return (
    <BoxForm>
      {parametersSchema.map((prebidModuleParameter: PrebidModuleParameter): React.JSX.Element => {
        const { label, name, required, tooltip, type } = prebidModuleParameter

        register(name, { value: prepareValue(name, parameters) })

        const inputKey: string = name

        const props: TextFieldProps<ParamsSchema> = {
          control,
          disabled: isDisabled,
          label: required ? `${label} *` : label,
          name: name,
          tooltip,
        }

        switch (type) {
          case 'float':
          case 'floatPercent':
          case 'integer': {
            return (
              <NumberField
                key={inputKey}
                {...props}
              />
            )
          }

          default: {
            if (name === 'topics') {
              return (
                <CodeField
                  height={CODE_FIELD_HEIGHT}
                  key={inputKey}
                  language='json'
                  options={{
                    folding: false,
                    lineNumbers: 'off',
                  }}
                  title={name}
                  {...props}
                />
              )
            } else {
              return (
                <TextField
                  key={inputKey}
                  {...props}
                />
              )
            }
          }
        }
      })}
    </BoxForm>
  )
}
